var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ipub-model',{attrs:{"title":"Reject Reason","width":"400px","visable":_vm.isVisable,"confirmText":"Re-edit"},on:{"confirm":_vm.confirm,"cancel":_vm.cancel}},[_c('div',{staticClass:"ipub-p2"},[_vm._v("\n    "+_vm._s(_vm.inputData)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }